import React from "react";
import { Warning, Phone } from "@phosphor-icons/react";

const PHONE_DISPLAY = "(919) 737-5442";
const PHONE_RAW = "+19197375442";

export default function EmergencyBanner() {
  return (
    <section
      data-testid="emergency-banner-section"
      className="relative bg-gradient-to-r from-red-600 via-red-600 to-red-700 text-white overflow-hidden"
    >
      {/* Subtle pattern */}
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, rgba(255,255,255,0.15) 0 10px, transparent 10px 22px)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 sm:py-6 flex flex-col sm:flex-row items-center gap-4 sm:gap-6 text-center sm:text-left">
        <div className="flex items-center gap-3 shrink-0">
          <div className="h-11 w-11 rounded-full bg-white/15 grid place-items-center border border-white/30">
            <Warning size={22} weight="fill" className="text-white" />
          </div>
          <div className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight">
            Business down?
          </div>
        </div>

        <div className="flex-1 text-sm sm:text-base leading-snug text-white/95">
          Same-day remote support is available for many issues. Call now to speak with a technician.
        </div>

        <a
          href={`tel:${PHONE_RAW}`}
          data-testid="emergency-call-btn"
          className="shrink-0 inline-flex items-center gap-2 rounded-full bg-white text-red-700 hover:bg-zinc-100 px-6 py-3 font-bold text-sm sm:text-base transition-all shadow-lg shadow-red-950/30"
        >
          <Phone size={18} weight="fill" />
          Call {PHONE_DISPLAY}
        </a>
      </div>
    </section>
  );
}
